export default __webpack_public_path__ + "static/media/five.549be87d.svg";